<div class="my-profile-shell">
  @if (mobileSidebarOpen) {
    <button type="button" class="my-profile-shell__backdrop" aria-label="Close sidebar" (click)="closeMobileSidebar()"></button>
  }

  <aside
    class="my-profile-shell__sidebar"
    [class.my-profile-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.my-profile-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="my-profile-shell__content">
    <app-dashboard-header
      [title]="title"
      [subtitle]="subtitle"
      [user]="headerUser"
      [currentTime]="currentTimeLabel"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="my-profile-page">
      <section class="my-profile-page__card">
        <div class="my-profile-page__visual">
          <div class="my-profile-page__badge">Profile</div>

          <div class="my-profile-page__preview">
            @if (displayProfileImageUrl) {
              <img [src]="displayProfileImageUrl || ''" [alt]="headerUser.fullName + ' profile image'" />
            } @else {
              <span>{{ headerUser.initials }}</span>
            }
          </div>

          <div class="my-profile-page__visual-copy">
            <h2>{{ profileDetails?.user_fullname || headerUser.fullName }}</h2>
            <p>{{ profileDetails?.role_display_name || profileDetails?.role_name || headerUser.roleLabel }} · {{ headerUser.department }}</p>
            <span>Keep your profile image up to date for a better dashboard experience.</span>
          </div>
        </div>

        <div class="my-profile-page__form">
          <div class="my-profile-page__heading">
            <p class="my-profile-page__eyebrow">Account settings</p>
            <h3>Manage Profile Image</h3>
            <p>Upload, update, or remove your profile image. Your account details below are read only.</p>
          </div>

          <section class="my-profile-page__details" aria-label="Profile details">
            <div class="my-profile-page__detail-card">
              <span>Username</span>
              <strong>{{ profileDetails?.username || '-' }}</strong>
            </div>
            <div class="my-profile-page__detail-card">
              <span>Full name</span>
              <strong>{{ profileDetails?.user_fullname || headerUser.fullName }}</strong>
            </div>
            <div class="my-profile-page__detail-card">
              <span>Email</span>
              <strong>{{ profileDetails?.email || '-' }}</strong>
            </div>
            <div class="my-profile-page__detail-card">
              <span>Mobile no.</span>
              <strong>{{ profileDetails?.mobile_no || '-' }}</strong>
            </div>
            <div class="my-profile-page__detail-card">
              <span>Role</span>
              <strong>{{ profileDetails?.role_display_name || profileDetails?.role_name || headerUser.roleLabel }}</strong>
            </div>
          </section>

          <div class="my-profile-page__field">
            <label class="my-profile-page__label" for="profile_image">Profile image</label>
            <input
              #profileInput
              id="profile_image"
              type="file"
              accept="image/*"
              class="my-profile-page__file-input"
              (change)="handleFileSelection($event)"
            />
            <div class="my-profile-page__file-meta">
              <span>{{ selectedFileName || currentProfileImage?.filename || 'No image selected' }}</span>
              <button type="button" class="my-profile-page__browse-button" (click)="openFilePicker()">Choose image</button>
            </div>
          </div>

          <div class="my-profile-page__actions">
            <button
              type="button"
              class="app-button app-button--primary"
              [disabled]="isSubmitting || isLoadingProfile || !selectedFile"
              (click)="saveProfileImage()"
            >
              {{ isSubmitting ? 'Saving...' : profileImageButtonLabel }}
            </button>

            @if (canDeleteProfileImage) {
              <button
                type="button"
                class="app-button app-button--secondary my-profile-page__delete-button"
                [disabled]="isSubmitting || isLoadingProfile"
                (click)="deleteProfileImage()"
              >
                Delete Image
              </button>
            }
          </div>

          @if (isLoadingProfile) {
            <div class="my-profile-page__message my-profile-page__message--info">Loading profile details...</div>
          }

          @if (successMessage) {
            <div class="my-profile-page__message my-profile-page__message--success">{{ successMessage }}</div>
          }

          @if (errorMessage) {
            <div class="my-profile-page__message my-profile-page__message--error">{{ errorMessage }}</div>
          }
        </div>
      </section>
    </main>
  </div>
</div>
